export const parseCalc = (calc: string | undefined, max: number) => {
  if (!calc) {
    return 0;
  }

  if (!isNaN(+calc)) {
    return +calc;
  }

  // If the value is a number with px, return it after removing px
  if (!isNaN(+calc.replace('px', ''))) {
    return +calc.replace('px', '');
  }

  // If the value is a number with %, return it after transforming to an absolute value based on the max value
  if (!isNaN(+calc.replace('%', ''))) {
    return (+calc.replace('%', '') * max) / 100;
  }

  // If the value is a calc function, parse it and return the result
  if (calc.startsWith('calc(')) {
    const clean = calc.replace('calc(', '').replace(')', '');
    const [first, operator, second] = clean.split(' ');

    const cleanFirst = first.includes('%')
      ? (+first.replace('%', '') * max) / 100
      : +first.replace('px', '');
    const cleanSecond = second.includes('%')
      ? (+second.replace('%', '') * max) / 100
      : +second.replace('px', '');

    if (isNaN(cleanFirst) || isNaN(cleanSecond)) {
      return 0;
    }

    switch (operator) {
      case '+':
        return cleanFirst + cleanSecond;
      case '-':
        return cleanFirst - cleanSecond;
      default:
        return 0;
    }
  }

  return 0;
};
